import { render, staticRenderFns } from "./Finalization.vue?vue&type=template&id=fd3682c6"
import script from "./Finalization.vue?vue&type=script&lang=js"
export * from "./Finalization.vue?vue&type=script&lang=js"
import style0 from "./Finalization.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports